<template>
    <div class="tsa-signPasswordV2" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <div class="title-top">
                <h4>签署密码</h4>
                <img @click="close" src="/static/img/icon/close.png" alt="">
            </div>
            <div class="scroll">
                <div class="icon">
                    <img src="/static/img/icon/suo.png" alt="">
                    <p>为了您的账户安全，签署操作需要验证密码</p>
                </div>
                <div class="form">
                    <div class="item">
                        <p class="name">输入签署密码</p>
                        <div class="value">
                            <input v-model="password" type="password" placeholder="输入签署密码">
                        </div>
                    </div>
                </div>
                <div class="forget" @click="forget">
                    <p>忘记密码</p>
                </div>
            </div>
            <div class="bottom">
                <div class="btn" @click="close">
                    <p>取消</p>
                </div>
                <div class="btn confirm" @click="confirm">
                    <p>确定</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'mint-ui';
import { signPasswordVerifyApi } from '@/api/common'
import { setBodyOverflow } from '@/js/utils'
export default {
    data () {
        return {
            show: false,
            contractId: '',
            signSessionId: '',
            verificationId: '',
            password: ''
        }
    },
    watch: {
        show (val) {
            setBodyOverflow(val)
            if (!val) {
                this.password = ''
                this.contractId = ''
                this.signSessionId = ''
                this.verificationId = ''
            }
        }
    },
    methods: {
        close () {
            this.show = false
        },
        forget () {
            this.show = false
            this.onForget && this.onForget()
        },
        confirm () {
            let password = this.password.trim()
            if (!password) {
                Toast({ message: '请输入签署密码', duration: 2000 })
                return
            }
            this.$TsaLoading.show()
            signPasswordVerifyApi({
                contractId: this.contractId,
                signSessionId: this.signSessionId,
                verificationId: this.verificationId,
                password
            }).then(res => {
                this.$TsaLoading.hide()
                if (res.code == '0') {
                    if (res.data.code === 200) {
                        this.show = false
                        this.onConfirm && this.onConfirm(res.data || {})
                    } else {
                        Toast({ message: res.data.message, duration: 2000 })
                    }
                }
            }).catch(() => {
                this.$TsaLoading.hide()
            })
            
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-signPasswordV2 {
        position: fixed;
        z-index: 9;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        * {
            box-sizing: border-box;
        }
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.65);
        }
        .content {
            display: flex;
            flex-direction: column;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            max-height: 95%;
            border-radius: 8px;
            background: #FFFFFF;
            border-radius: 16px 16px 0px 0px;
            .title-top {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 24px;
                padding: 16px 20px 0 16px;
                h4 {
                   font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                }
                img {
                    width: 24px;
                    height: 24px;
                }
            }
            .scroll {
                flex: 1;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                padding: 0 16px;
                .forget {
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    margin-bottom: 32px;
                    p {
                        font-size: 14px;
                        color: #0047FF;
                    }
                }
            }
            .icon {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 40px;
                img {
                    width: 62px;
                    height: 62px;
                    margin-bottom: 24px;
                }
                p {
                    font-weight: bold;
                    font-size: 14px;
                    color: #999999;
                }
            }
            .form {
                .item {
                    margin-bottom: 24px;
                    .name {
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                        margin-bottom: 8px;
                    }
                    .value {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        background: #F7F9FD;
                        border-radius: 8px;
                        padding: 8px 12px;
                        border: 1px solid #F7F9FD;
                        input {
                            flex: 1;
                            font-size: 14px;
                            color: #333333;
                            border: 0;
                            outline: none;
                            -webkit-appearance: none;
                            appearance: none;
                            background-color: transparent;
                            &::placeholder {
                                font-size: 14px;
                                color: #666666;
                            }
                        }
                        button {
                            font-size: 14px;
                            color: #0047FF;
                            border: 0;
                            outline: none;
                            background: transparent;
                            -webkit-appearance: none;
                            appearance: none;
                            padding: 0;
                            margin: 0;
                            cursor: pointer;
                            white-space: nowrap;
                            flex-shrink: 0;

                            &:disabled {
                                color: #999999;
                                cursor: not-allowed;
                            }
                        }
                    }
                }
            }
            .bottom {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                padding: 16px;
                box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.05);
                .btn {
                    flex: 1;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 162px;
                    height: 44px;
                    border-radius: 8px;
                    border: 1px solid #D9D9D9;
                    p {
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .confirm {
                    margin-left: 12px;
                    background: linear-gradient( 90deg, #0047FF 0%, #2377FF 100%);
                    p {
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/signPasswordV2/index.vue